'use client';

import useGetLoginInfoQuery from '@module/helpers/auth/useGetLoginInfoQuery';
import { cn } from '@module/lib/utils';
import useModalStore from '@module/stores/useModalStore';
import { MODAL_TYPE_PC } from '@module/types/modal/type';
import BaseButton from '@pc/components/atoms/button/BaseButton';
import { useRouter } from 'next/navigation';

interface SignatureEmoticonRegisterButtonProps {
  className?: string;
}

function SignatureEmoticonRegisterButton({ className }: SignatureEmoticonRegisterButtonProps) {
  const { isLogin, userInfo } = useGetLoginInfoQuery();
  const router = useRouter();
  const pushModal = useModalStore((state) => state.pushModal);

  const handleClick = () => {
    if (isLogin && userInfo) {
      router.push(`/channel/${userInfo.id}/config/signature`);
    } else {
      pushModal({
        type: MODAL_TYPE_PC.AUTH_MODAL,
        id: 'SignatureEmoticonRegisterButton',
      });
    }

    // 페이지 상단으로 스크롤
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className={cn('mt-20 flex justify-center', className)}>
      <BaseButton type='button' onClick={handleClick} size='md' variant='primary' className='text-[17px]'>
        시그니처이모티콘 등록
      </BaseButton>
    </div>
  );
}

export default SignatureEmoticonRegisterButton;
